<template lang="pug">
v-container
  v-dialog(
    :value="!!showDetails",
    @input="showDetails = null",
    max-width="900"
  )
    extra-content(:extra="{ content: showDetails }")

  v-card.mb-3 
    v-card-title.headline.primary--text ARBEITS- UND GESUNDHEITSSCHUTZ
      //- .grey--text . Basisinfos und Tipps
    v-card-text 
      v-layout(row, wrap)
        v-flex(xs12, sm9)
          v-tabs(slider-color="#0053A6" active-class="active_tab")
            template(v-for="topic in arbeitsschutzCategories")
              v-tab {{topic}}
              v-tab-item.mt-3
                template(v-for="eintrag in arbeitsschutzContents")
                  template(v-if="eintrag.kategorie.name == topic")
                    v-flex(xs6): v-btn(@click="show(eintrag)" flat :color="primary") {{ eintrag.title }}
        v-flex(xs12, sm3, transparent-body)
          v-img(:src="sicherheitbild")
          
  v-card.mb-3
    v-card-title.headline.primary--text MARKTPLATZ
      .grey--text . Angebot diverser Kurse, Infos zur Anmeldung jeweils in den Details
    v-card-text
      v-layout(row, wrap)
        v-flex(xs12, sm12)
           v-tabs(slider-color="#0053A6" active-class="active_tab")
            template(v-for="topic in marktplatzCategories")
              v-tab {{topic}}
              v-tab-item.mt-3
                template(v-for="eintrag in marktplatzContents")
                  template(v-if="eintrag.kategorie.name == topic")
                    v-flex(xs6): v-btn(@click="show(eintrag)" flat :color="primary") {{ eintrag.title }}      
                    v-flex(v-if="eintrag.kategorie.imageUrl != null" xs12, sm3, class="ml-auto p-2"): v-img(:src="eintrag.kategorie.imageUrl" :max-height="250" :max-width="500")

  v-card.mb-3 
    v-card-title.headline.primary--text GESUNDHEITSMAGAZIN
      .grey--text . Basisinfos und Tipps
    v-card-text 
      v-layout(row, wrap)
        v-flex(xs12, sm9)
          v-tabs(slider-color="#0053A6" active-class="active_tab")
            template(v-for="topic in magazinCategories")
              v-tab {{topic}}
              v-tab-item.mt-3
                template(v-for="eintrag in magazinContents")
                  template(v-if="eintrag.kategorie.name == topic")
                    div(@click="show(eintrag)" style="cursor: pointer;")
                      v-layout(row, wrap)
                        v-flex(xs12, sm2)
                          v-img(:src="eintrag.previewImage" :max-height="150" :max-width="200") 
                        v-flex(xs12, sm10)
                          h3 {{eintrag.title}}
                          h(v-if="eintrag.preamble != '.'" ) {{eintrag.preamble}}



  v-card.mb-3 
    v-card-title.headline.primary--text HVD Aktiv
      .grey--text . Hier direkt bei Events anmelden
    v-card-text 
      v-layout(row, wrap)
        v-flex(xs12, sm9)
          v-btn(
            round,
              href="https://forms.office.com/pages/responsepage.aspx?id=je37Hd3K70CVc1eXgKnGu1lv1BKc2-VFjHc1ofHgjrJUNVpMRTM0VkZDVDcxOFpLVjRGRkczQllGMi4u",
              target="_blank",
              color="green"
            ) Teamstaffel
          v-btn(round, color="green", style="width: 60px",disabled) Massage
          
        v-flex(xs12, sm3)
          v-img(:src="hvdaktivbild") 
  //- v-card.list-card.mb-4(v-for="submenue in submenues" xs6)
  //-   v-img(v-if="submenue.image" :src="submenue.image" :aspect-ratio="16/9")
  //-   v-card-title.grey.lighten-4
  //-   | {{ submenue.titel }}
  //-   //- router-link(:to="contentUrl(content)").subheading {{content.title}}
  //-   v-card-text(v-if="submenue.preamble") {{submenue.preamble}}
</template>


<style lang="stylus">
.active_tab 
  color: rgba(0,83,166,1) !important;
  opacity: 1 !important
</style>

<script>
import gql from "graphql-tag";
import { sortBy, uniq } from 'lodash';

import ExtraItTermineUebersicht from "./extra-it-termine-uebersicht";
import ExtraItTicketStatistik from "./extra-it-ticket-statistik";
import ExtraItTicketHistorie from "./extra-it-ticket-historie";
//import ExtraDownloadList from './extra-download-list'
import ExtraContent from "./extra-content";

export default {
  props: ["extra"],
  // mixins: [GraphqlErrorObject],
  components: {
    ExtraItTermineUebersicht,
    ExtraItTicketStatistik,
    ExtraItTicketHistorie,
    // ExtraDownloadList,
    ExtraContent,
  },
  data() {
    return {
      chosen: 0,
      // submenues: [
      //   {titel: 'Marktplatz', preamble: 'hier kann man dies und das und das.', image: require('../../images/badvibes_um.png')},
      //   {titel: 'Gesundheitsmagazin', preamble: 'hier kann man dies und das und das.', image: require('../../images/badvibes.png')},
      //   {titel: 'Infobörse', preamble: 'hier kann man dies und das und das.', image: require('../../images/badvibes.png')},
      //   {titel: 'HVD Aktiv', preamble: 'hier kann man dies und das und das.', image: require('../../images/badvibes.png')},
      // ],
      marktplatzbild: require("../../images/markt.JPG"),
      sicherheitbild: require("../../images/sicherheit.png"),
      hvdaktivbild: require("../../images/hvdaktiv_gesundbox.jpg"),
      opendialog: false,
      showDetails: null,
      gesundMarktplatzContentsCategoryIds: [],
      marktplatzContents: [],
      gesundMagazinContentsCategoryIds: [],
      magazinContents: [],
      gesundArbeitsschutzContentsCategoryIds: [],
      arbeitsschutzContents: [],
    };
  },
  apollo: {
    gesundMarktplatzContentsCategoryIds: gql`
      query ExtraGesundboxMarktplatzKategorien {
        gesundMarktplatzContentsCategoryIds
      }
    `,
    marktplatzContents: {
      query: gql`
        query ExtraGesundboxMartkplatz($catIds: [ID!]) {
          marktplatzContents: beitraege(where: { categoryIdIn: $catIds }) {
            id
            categoryId
            kategorie {
              name
              imageUrl
            }
            metaDescription

            title
            preamble
            content
            downloads {
              id
              url
              title
            }
            previewImage
          }
        }
      `,
      variables() {
        return { catIds: this.gesundMarktplatzContentsCategoryIds };
      },
    },
    gesundArbeitsschutzContentsCategoryIds: gql`
      query ExtraGesundboxArbeitsschutzKategorien {
        gesundArbeitsschutzContentsCategoryIds
      }
    `,
    arbeitsschutzContents: {
      query: gql`
        query ExtraGesundboxArbeitsschutz($catIds: [ID!]) {
          arbeitsschutzContents: beitraege(where: { categoryIdIn: $catIds }) {
            id
            categoryId
            kategorie {
              name
            }
            metaDescription

            title
            preamble
            content
            downloads {
              id
              url
              title
            }
            previewImage
          }
        }
      `,
      variables() {
        return { catIds: this.gesundArbeitsschutzContentsCategoryIds };
      },
    },
    gesundMagazinContentsCategoryIds: gql`
      query ExtraGesundboxMagazinKategorien {
        gesundMagazinContentsCategoryIds
      }
    `,
    magazinContents: {
      query: gql`
        query ExtraGesundboxMagazin($catIds: [ID!]) {
          magazinContents: beitraege(where: { categoryIdIn: $catIds }) {
            id
            categoryId
            kategorie {
              name
            }
            metaDescription

            title
            preamble
            content
            downloads {
              id
              url
              title
            }
            previewImage(size: "150x")
          }
        }
      `,
      variables() {
        return { catIds: this.gesundMagazinContentsCategoryIds };
      },
    },
  },
  computed: {
    marktplatzCategories() {
      let marktplatzCategories = [];
      this.marktplatzContents.forEach((content) => {
        // marktplatzCategories.push(content.categoryId);
        marktplatzCategories.push(content.kategorie.name);
        // marktplatzCategories.push([content.categoryId, content.kategorie.name]);
      });
      marktplatzCategories = uniq(marktplatzCategories).sort()
      return marktplatzCategories;
    },
    magazinCategories() {
      let magazinCategories = [];
      this.magazinContents.forEach((content) => {
        // marktplatzCategories.push(content.categoryId);
        magazinCategories.push(content.kategorie.name);
        // marktplatzCategories.push([content.categoryId, content.kategorie.name]);
      });
      magazinCategories = uniq(magazinCategories).sort()
      return magazinCategories;
    },
    arbeitsschutzCategories() {
      let arbeitsschutzCategories = [];
      this.arbeitsschutzContents.forEach((content) => {
        arbeitsschutzCategories.push(content.kategorie.name);
      });
      arbeitsschutzCategories = uniq(arbeitsschutzCategories).sort()
      return arbeitsschutzCategories;
    },
  },
  methods: {
    show(content) {
      this.showDetails = content;
      this.showDetails = JSON.stringify([this.showDetails]);
    },
  },
};
</script>
